<div>
  <angular2-smart-table-tag
    *ngFor="let tag of tags"
    [item]="tag"
    (close)="closedTag($event)"
  ></angular2-smart-table-tag>
</div>
